import {
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
} from '@/utils/const.js';

export default [{
  path: '/dashboards',
  name: 'dashboards',
  component: () => import('@/views/dashboards/index.vue'),
  meta: {
    title: 'Dashboards',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_EXPERT,
        ROLE_PROJECT_MNG,
      ],
    },
  },
},
{
  path: '/dashboards/company',
  name: 'dashboards_tq',
  component: () => import('@/views/dashboards/tq/index.vue'),
  meta: {
    title: 'Dashboards | TQ',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_EXPERT,
        ROLE_PROJECT_MNG,
      ],
    },
  },
  children: [{
    path: '',
    name: 'company',
    component: () => import('@/views/dashboards/tq/kpi/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: 'results',
    name: 'results',
    component: () => import('@/views/dashboards/tq/results/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: 'trends',
    name: 'trends',
    component: () => import('@/views/dashboards/tq/trends/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  ],
},
{
  path: '/dashboards/vendors',
  name: 'dashboards_vendors',
  component: () => import('@/views/dashboards/dashboards_vendors/index.vue'),
  meta: {
    title: 'Dashboards | Vendors',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_EXPERT,
        ROLE_PROJECT_MNG,
      ],
    },
  },
  children: [{
    path: '',
    name: 'vendors',
    component: () => import('@/views/dashboards/dashboards_vendors/kpi/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: 'results',
    name: 'results',
    component: () => import('@/views/dashboards/dashboards_vendors/results/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: 'trends',
    name: 'trends',
    component: () => import('@/views/dashboards/dashboards_vendors/trends/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  ],
},
{
  path: '/dashboards/errors_intelligence',
  name: 'errors_intelligence',
  component: () => import('@/views/dashboards/errors_intelligence/index.vue'),
  meta: {
    title: 'Dashboards | Errors intelligence',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_PROJECT_MNG,
        ROLE_QA_EXPERT,
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/dashboards/rating_map',
  component: () => import('@/views/dashboards/map/index.vue'),
  meta: {
    title: 'Dashboards | Rating map',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_EXPERT,
        ROLE_PROJECT_MNG,
      ],
    },
  },
  children: [{
    path: '',
    name: 'dashboards_map_kpi',
    component: () => import('@/views/dashboards/map/kpi/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: 'results',
    name: 'dashboards_map_results',
    component: () => import('@/views/dashboards/map/results/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: 'trends',
    name: 'dashboards_map_trends',
    component: () => import('@/views/dashboards/map/trends/index.vue'),
    meta: {
      title: 'Dashboards | TQ',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_QA_EXPERT,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  ],
},
{
  path: '/dashboards/ranking',
  component: () => import('@/views/dashboards/ranking/index.vue'),
  meta: {
    title: 'Dashboards | Ranking Dashboards',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_EXPERT,
        ROLE_PROJECT_MNG,
      ],
    },
  },
},
{
  path: '/dashboards/overall',
  name: 'overall',
  component: () => import('@/views/dashboards/overall/index.vue'),
  meta: {
    title: 'Dashboards | Overall',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_EXPERT,
        ROLE_PROJECT_MNG,
      ],
    },
  },
},
];
